import React from "react";
import { useTranslation } from "react-i18next";

import { Team, Tournament } from "@gp/models";

import { StreakStat } from "@data-types/sport-stats/SportStatsTypes";

import TeamIcon from "@components/icons/TeamIcon";

export const StreakStatItem = (props: {
	item: StreakStat;
	tournament: Tournament | undefined;
	homeTeam: Team | undefined;
	awayTeam: Team | undefined;
}) => {
	const { item, tournament, homeTeam, awayTeam } = props;

	const { t } = useTranslation();

	const homeIcon = (
		<TeamIcon
			showCountryFlag={tournament?.showCountryFlag}
			flagCode={homeTeam?.countryCode}
			jerseyTypeAbrv={homeTeam?.jerseyTypeAbrv}
			opponentFlagCode={awayTeam?.countryCode}
			opponentJerseyTypeAbrv={awayTeam?.jerseyTypeAbrv}
			className="card--stats__icon u-icon--big"
		/>
	);

	const awayIcon = (
		<TeamIcon
			showCountryFlag={tournament?.showCountryFlag}
			flagCode={awayTeam?.countryCode}
			jerseyTypeAbrv={awayTeam?.jerseyTypeAbrv}
			opponentFlagCode={homeTeam?.countryCode}
			opponentJerseyTypeAbrv={homeTeam?.jerseyTypeAbrv}
			className="statistics__icon u-icon--big"
		/>
	);

	const mainTeam = item.team === "home" ? homeTeam : awayTeam;
	const icon = item.team === "home" ? homeIcon : awayIcon;

	if (item.team === "both") {
		return (
			<>
				{renderStreak(
					homeTeam,
					t("EVENT.OFFER.COMPETITOR_HOME"),
					homeIcon,
					item
				)}
				{renderStreak(
					awayTeam,
					t("EVENT.OFFER.COMPETITOR_AWAY"),
					awayIcon,
					item
				)}
			</>
		);
	}

	return renderStreak(
		mainTeam,
		item.team === "home"
			? t("EVENT.OFFER.COMPETITOR_HOME")
			: t("EVENT.OFFER.COMPETITOR_AWAY"),
		icon,
		item
	);
};

const renderStreak = (
	team: Team | undefined,
	label: string,
	icon: React.ReactNode,
	item: StreakStat
) => {
	const { t } = useTranslation();

	return (
		<div
			key={`${item.abrv}-${label.toLowerCase()}`}
			className="statistics__row"
		>
			<div className="statistics__col">
				<div className="statistics__team">
					{icon}
					<span className="statistics__name">{label}</span>
				</div>
			</div>
			<div className="statistics__col">
				{t(`EVENT.STATISTICS.STREAK_STATS.${item.abrv}`, {
					margin: item.margin,
				})}
			</div>
			<div className="statistics__col">{item.value}</div>
		</div>
	);
};
